export default __webpack_public_path__ + "static/media/treetrail.f909a9d2.svg";